// This script triggers Searchspring recommendations when the cart drawer opens
(function() {
  function triggerSearchspring() {
    if (window.searchspring?.controller['recommend_side-cart_0']?.retarget) {
      window.searchspring.controller['recommend_side-cart_0'].retarget();
    }
  }

  document.addEventListener('dialog:after-show', function(e) {
    // Only trigger for cart drawer
    if (e.target && e.target.tagName && e.target.tagName.toLowerCase() === 'cart-drawer') {
      triggerSearchspring();
    }
  });
})();
